import { RIGHT_LABELS } from '@/api/onboarding'

export function BotPermissionsMock({ granted, missing }: { granted: string[]; missing: string[] }) {
  const status = (key: string): 'on' | 'off' | 'alert' => {
    if (missing.includes(key)) return 'alert'
    if (granted.includes(key)) return 'on'
    return 'off'
  }

  const rows: { key: string; group: number; alwaysDim?: boolean; sub?: string; alwaysTag?: 'opt' }[] = [
    { key: 'change_chat_info', group: 1, alwaysDim: true, alwaysTag: 'opt', sub: 'Фото, название, описание' },
    { key: 'write', group: 2 },
    { key: 'edit', group: 2 },
    { key: 'delete', group: 2 },
    { key: 'pin_message', group: 2 },
    { key: 'add_remove_members', group: 3 },
    { key: 'add_admins', group: 4, alwaysDim: true, alwaysTag: 'opt', sub: 'Сможет удалять только администраторов, которых назначил самостоятельно' },
  ]
  const groups = [1, 2, 3, 4]

  return (
    <aside className="max-mock" aria-label="Как выглядит экран прав бота в MAX">
      <div className="max-mock-cap">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="6" y="2" width="12" height="20" rx="3" />
          <path d="M11 19h2" />
        </svg>
        Как это выглядит в MAX
      </div>
      <div className="max-mock-body">
        <div className="mm-bot">
          <div className="mm-av" aria-hidden>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7z" />
            </svg>
          </div>
          <div className="mm-bot-nm">TeleGraphyx бот продвижения</div>
        </div>

        {groups.map((g) => (
          <div className="mm-grp" key={g}>
            {rows.filter((r) => r.group === g).map((r) => {
              const st = r.alwaysDim ? 'off' : status(r.key)
              return (
                <div key={r.key} className={`mm-row ${st === 'alert' ? 'alert' : ''} ${r.alwaysDim ? 'dim' : ''}`}>
                  <div>
                    <div className="mm-row-nm">
                      {RIGHT_LABELS[r.key] || `«${r.key}»`}
                      {r.alwaysTag === 'opt' && <span className="mm-tag opt">можно оставить</span>}
                      {st === 'alert' && <span className="mm-tag need">нужно</span>}
                    </div>
                    {r.sub && <div className="mm-row-sub">{r.sub}</div>}
                  </div>
                  <span className={`mm-toggle ${st === 'on' ? 'on' : ''}`} />
                </div>
              )
            })}
          </div>
        ))}

        <p className="mm-note">
          Красным подсвечено то, что нужно включить.
          <br />
          Серое можно не трогать.
        </p>
      </div>

      <style>{`
        .max-mock {
          width: 100%;
          max-width: 360px;
          background: #0f1218;
          border-radius: 26px;
          padding: 12px 12px 14px;
          color: white;
          box-shadow: 0 20px 44px -18px rgba(15, 18, 24, 0.45);
          box-sizing: border-box;
        }
        .max-mock-cap {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 7px 12px;
          border-radius: 999px;
          background: rgba(255,255,255,0.08);
          color: rgba(255,255,255,0.85);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .max-mock-cap svg { width: 14px; height: 14px; }
        .max-mock-body {
          background: #171b22;
          border-radius: 20px;
          padding: 14px 12px 12px;
        }
        .mm-bot {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 0 4px 12px;
          margin-bottom: 10px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .mm-av {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          background: linear-gradient(135deg, #4d9fff, #7c3aed);
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .mm-av svg { width: 18px; height: 18px; }
        .mm-bot-nm { font-size: 13px; font-weight: 700; color: white; }
        .mm-grp + .mm-grp {
          margin-top: 10px;
          padding-top: 10px;
          border-top: 1px solid rgba(255,255,255,0.06);
        }
        .mm-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 12px;
          padding: 10px 6px;
          border-radius: 12px;
          transition: background 200ms ease;
        }
        .mm-row.alert {
          background: rgba(255, 64, 0, 0.10);
          animation: mm-alert-pulse 1.6s ease-in-out infinite;
        }
        @keyframes mm-alert-pulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(255, 64, 0, 0); }
          50% { box-shadow: 0 0 0 4px rgba(255, 64, 0, 0.10); }
        }
        .mm-row.dim { opacity: 0.6; }
        .mm-row-nm {
          font-size: 13px;
          font-weight: 600;
          color: white;
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          align-items: center;
        }
        .mm-row-sub {
          font-size: 11px;
          color: rgba(255,255,255,0.5);
          margin-top: 3px;
          line-height: 1.4;
          max-width: 210px;
        }
        .mm-tag {
          display: inline-flex;
          align-items: center;
          padding: 3px 7px;
          border-radius: 999px;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.04em;
          text-transform: uppercase;
        }
        .mm-tag.opt {
          background: rgba(255,255,255,0.08);
          color: rgba(255,255,255,0.7);
        }
        .mm-tag.need {
          background: rgba(255, 64, 0, 0.16);
          color: #ff8d78;
        }
        .mm-toggle {
          position: relative;
          width: 38px;
          height: 22px;
          border-radius: 999px;
          background: rgba(255,255,255,0.18);
          flex-shrink: 0;
        }
        .mm-toggle::after {
          content: "";
          position: absolute;
          top: 3px;
          left: 3px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: white;
          transition: transform 180ms ease, background 180ms ease;
        }
        .mm-row.alert .mm-toggle {
          background: rgba(255, 64, 0, 0.40);
        }
        .mm-row.alert .mm-toggle::after {
          background: #ff8d78;
        }
        .mm-toggle.on {
          background: rgba(0, 168, 96, 0.55);
        }
        .mm-toggle.on::after {
          transform: translateX(16px);
        }
        .mm-note {
          margin: 12px 4px 0;
          font-size: 11.5px;
          color: rgba(255,255,255,0.58);
          line-height: 1.45;
        }
        @media (max-width: 640px) {
          .max-mock {
            max-width: none;
            border-radius: 22px;
          }
          .max-mock-body {
            border-radius: 18px;
          }
          .mm-row {
            padding-left: 2px;
            padding-right: 2px;
          }
          .mm-row-sub {
            max-width: none;
          }
        }
      `}</style>
    </aside>
  )
}
